<!-- <p class="availabilityStatus">
  Currently Unavailable!
</p> -->

<p class="availabilityStatusWrapper" [ngClass]="customClass">
  <!-- <mat-icon>access_time</mat-icon> -->
  <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
    class="lucide lucide-triangle-alert w-4 h-4 text-red-600">
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
    <path d="M12 9v4"></path>
    <path d="M12 17h.01"></path>
  </svg> -->
  This feature is temporarily unavailable
</p>